const styles = (theme) => ({
  holidayGridContainer: {
    maxWidth: "68%",
    padding: 0,
    "& $gridHead": {
      minHeight: 32,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    "& $dataGrid": {
      maxHeight: "65%",
      height: "65%"
    }
  },
  holidayGrid: {
    margin: "20 0 60 0",
    height: 300
  },
  paperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 100,
    backgroundColor: theme.ModalBGColor,
  },
});

export default styles;
